import { useShortCodeDataCemeteries } from '@/hooks/use-short-code-data/use-short-code-data'
import { useState, FC } from 'react'
import { CemeteryInfo } from './CemeteryInfo'
import { RecommendPoints } from './RecommendPoints'
import { Review } from './Review'
import { Tabs, Tab, TabPanel } from '@lifedot/atoms/Tabs'
import { css } from '@emotion/react'
import { palette } from '@lifedot/styles/palette'
import { typography } from '@lifedot/styles/typography'
import { mq } from '@lifedot/styles/mediaQuery'

const styles = {
  tabs: css({
    marginBottom: -1,
    width: '70%',
    [mq('sp')]: {
      width: '100%'
    },
    '[aria-selected="false"]': {
      backgroundColor: palette.gray1
    },
    '[aria-selected="true"]': {
      backgroundColor: palette.background
    }
  }),
  tabPanel: css({
    border: `1px solid ${palette.gray4}`,
    backgroundColor: palette.background,
    padding: '16px 20px',
    [mq('sp')]: {
      padding: 16
    }
  })
}

interface TabbedCemeteryCardProps {
  cemeteryId: number
}

export const TabbedCemeteryCard: FC<TabbedCemeteryCardProps> = ({
  cemeteryId
}) => {
  const [currentTab, setCurrentTab] = useState(0)

  const [cemetery] = useShortCodeDataCemeteries([cemeteryId])

  if (!cemetery) return null

  const { review_summary: reviewSummary } = cemetery

  return (
    <article key={cemeteryId}>
      <div css={styles.tabs}>
        <Tabs handleTab={setCurrentTab} value={currentTab} aria-label="tabList">
          <Tab label={<span css={typography.textS}>基本情報</span>} />
          <Tab label={<span css={typography.textS}>特徴</span>} />
          {reviewSummary.count > 0 && (
            <Tab label={<span css={typography.textS}>口コミ</span>} />
          )}
        </Tabs>
      </div>
      <div css={styles.tabPanel}>
        <TabPanel index={0} value={currentTab}>
          <CemeteryInfo {...cemetery} />
        </TabPanel>
        <TabPanel index={1} value={currentTab}>
          <RecommendPoints {...cemetery} />
        </TabPanel>
        {reviewSummary.count > 0 && (
          <TabPanel index={2} value={currentTab}>
            <Review {...cemetery} />
          </TabPanel>
        )}
      </div>
    </article>
  )
}
